<template>
    <div id="podomashnemu">
        <section class="welcome">
            <div class="bg"><span></span></div>
            <div class="start">
                <h1><span>&laquo;По-домашнему с&nbsp;Кубани&raquo;: лучший в&nbsp;своей категории вкус!</span></h1>

                <div class="text">Следуя народным кубанским традициям, команда высококвалифицированных специалистов &laquo;Коровки из&nbsp;Кореновки&raquo; воспроизвела на&nbsp;современном оборудовании старинный способ приготовления молочных продуктов&nbsp;&mdash; индивидуальное сквашивание и&nbsp;томление &laquo;как в&nbsp;печи&raquo;.</div>
                
                <h3>Индивидуальное сквашивание и&nbsp;томление &laquo;как в&nbsp;печи&raquo;</h3>
                
                <div class="block">Когда-то давно наши предки в&nbsp;деревнях и&nbsp;на&nbsp;хуторах заквашивали молочную продукцию именно в&nbsp;печи. 
                Делали они ее&nbsp;с&nbsp;любовью, &laquo;по-домашнему&raquo;. В&nbsp;современном мире эта технология называется термостатной: продукт сквашивается 
                индивидуально в&nbsp;упаковке, не&nbsp;подвергаясь механическому воздействию, что делает его структуру густой, плотной, но&nbsp;при этом нежной&nbsp;и тающей 
                во&nbsp;рту.</div>
                <div class="block"> 
                Вкус продукта, произведенного термостатным способом, получается естественным и&nbsp;более насыщенным.</div>
                
                <h3>Естественный молочный вкус и&nbsp;необыкновенная густая консистенция</h3>
                
                <div class="block">Так появилась продукция &laquo;По-домашнему с&nbsp;Кубани&raquo;. Большая ее&nbsp;часть производится термостатным способом, что 
                позволяет сохранять все полезные свойства продуктов. Продукцию &laquo;По-домашнему с&nbsp;Кубани&raquo; отличают естественный молочный вкус и&nbsp;необыкновенная 
                густая консистенция.</div> 
                <div class="block">Употребление термостатных молочных продуктов способствует улучшению работы пищеварения, укреплению иммунитета и&nbsp;обогащению 
                организма витаминами. Для производства используется только отборное молоко высочайшего качества.</div>
            </div>
            
            <div class="list">
                <h2>Награды</h2>
                
<!--                
                <div class="item item-img1">
                    <div class="item-content">
                        <h3>Сметана термостатная, 20%, в&nbsp;стакане</h3>
                        <p>Золотая медаль &laquo;За&nbsp;качество&raquo; и&nbsp;диплом&nbsp;I степени на&nbsp;<nobr>23-й</nobr> Международной выставке продуктов питания, напитков и&nbsp;сырья для их&nbsp;производства &laquo;Продэкспо-2016&raquo;, конкурс &laquo;За&nbsp;высокие потребительские свойства&raquo;</p>
                        <p>Получение российского Знака качества от&nbsp;АНО &laquo;Российская система качества&raquo; (Роскачество), 2018&nbsp;г.</p>
                    </div>
                </div>
-->

                <div class="item item-img2">
                    <div class="item-content">
                        <h3>Творог, 9%</h3>
                        <p>Золотая медаль &laquo;За&nbsp;качество&raquo; и&nbsp;диплом&nbsp;I степени на&nbsp;<nobr>23-й</nobr> Международной выставке продуктов питания, напитков и&nbsp;сырья для их&nbsp;производства &laquo;Продэкспо-2016&raquo;, конкурс &laquo;За&nbsp;высокие потребительские свойства&raquo;</p>
                        <p>Получение российского Знака качества от&nbsp;АНО &laquo;Российская система качества&raquo; (Роскачество), 2018&nbsp;г.</p>
                    </div>
                </div>
                
                <div class="item item-img3">
                    <div class="item-content">
                        <h3>Варенец термостатный, 4%</h3>
                        <p>Серебряная медаль в&nbsp;номинации &laquo;Кефир и&nbsp;кисломолочная продукция&raquo; на&nbsp;Дегустационном конкурсе молочной продукции &laquo;Кубаньпродэскпо-2013&raquo;</p>
                    </div>
                </div>
            </div>
            <div class="lenta">

                <news></news>

                <!--<div class="lenta-logo"></div>-->
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "Homey"
    }
</script>
